import React from 'react'
import './styles.css'

export function SectionTitle(props) {
  return <h2 className="section-title">{props.children}</h2>
}

export default SectionTitle
